export default __webpack_public_path__ + "static/frase4-d3ccc7a5807d1bdfee890b6716714ea3.png";